// Données d'un écran : un endpoint /api/views/… renvoie exactement les
// propriétés que l'ancien composant serveur passait à sa vue. Tant que `data`
// manque, une page de l'app rend `ViewFallback` (app/src/components/
// page-states.tsx) : son squelette, ou l'erreur et sa reprise — jamais `null`.
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { apiFetch } from "./api";
import { setPageTitle } from "./tab-status";

/**
 * `keepPrevious` : pendant qu'un filtre change l'adresse, l'écran garde les
 * données précédentes au lieu de repasser par son état de chargement.
 */
export function useView<T>(path: string | null, options?: { keepPrevious?: boolean }) {
  return useQuery({
    queryKey: [path],
    queryFn: () => apiFetch<T>(path!),
    enabled: path !== null,
    placeholderData: options?.keepPrevious ? keepPreviousData : undefined,
  });
}

/** Titre de l'onglet (l'ancien `metadata.title`), que l'état du passage peut préfixer. */
export function usePageTitle(title: string) {
  useEffect(() => {
    setPageTitle(title);
  }, [title]);
}
